<div class="navbar-container flex flex-auto flex-col content-stretch items-stretch justify-between">
  <div class="flex flex-row content-center items-center justify-start">
    <mat-icon [svgIcon]="SparrowIcon.SparrowIcon" class="flex size-9! flex-[0_0_63px]" />
    <mat-icon
      [@animateText]="sideNavState ? 'show' : 'hide'"
      [svgIcon]="SparrowIcon.SparrowLabel"
      class="flex flex-[0_0_104px]"
    />
  </div>
  <div class="flex flex-col content-stretch items-stretch justify-stretch gap-8">
    @for (link of siteLinks; track link.url) {
      @if (link.isVisible) {
        <a
          #rla1="routerLinkActive"
          [ngClass]="rla1.isActive ? 'active' : ''"
          [routerLinkActiveOptions]="{ exact: false }"
          [routerLink]="link.url"
          class="nav-anchor flex h-10! flex-row content-center items-center justify-start"
          routerLinkActive="active-route"
        >
          <mat-icon [svgIcon]="link.icon" class="flex size-10! flex-[0_0_60px]" />
          <span [@animateText]="sideNavState ? 'show' : 'hide'">{{ link.label }}</span>
        </a>
      }
    }
  </div>
  <div class="flex flex-col content-stretch items-stretch justify-stretch gap-6">
    <div class="flex h-8 flex-row content-center items-center justify-start">
      <div class="lang-abbr flex flex-[0_0_63px] justify-center opacity-60">{{ selectedLanAbbr | uppercase }}</div>
      <div
        (mouseenter)="onLangToggle()"
        (mouseleave)="onLangToggle()"
        [@animateText]="sideNavState ? 'show' : 'hide'"
        class="dropdown flex flex-[0_0_124px]"
      >
        <div class="flex flex-row content-center items-center justify-start"
          ><span class="sp-body-12 cursor-pointer opacity-80!">{{ selectedLanLabel }}</span
          ><mat-icon
            [style]="{ transform: langDropdown ? 'rotate(180deg)' : 'none' }"
            [svgIcon]="SparrowIcon.CaretDown"
            class="size-4! opacity-80"
        /></div>
        @if (langDropdown) {
          <div class="dropdown-content flex flex-col content-stretch items-stretch justify-between">
            @for (loc of localizationLinks; track loc.lang) {
              <button (click)="changeLanguage(loc.lang)">
                {{ loc.label }}
              </button>
            }
          </div>
        }
      </div>
    </div>

    <a
      #rl_user="routerLinkActive"
      [ngClass]="rl_user.isActive ? 'active' : ''"
      [routerLinkActiveOptions]="{ exact: false }"
      class="nav-anchor user-anchor flex h-8 flex-row content-center items-center justify-stretch"
      routerLink="/user-manager"
      routerLinkActive="active-route"
    >
      <mat-icon
        [svgIcon]="isUserManager ? SparrowIcon.UserCircleGear : SparrowIcon.UserCircle"
        class="flex flex-[0_0_63px]"
      />
      <span [@animateText]="sideNavState ? 'show' : 'hide'" class="sp-body-12 cursor-pointer opacity-80!">
        @if (isUserManager) {
          <ng-container>User Manager</ng-container>
        } @else {
          <ng-container>Settings</ng-container>
        }
      </span>
    </a>

    <button (click)="logout()" class="nav-btn flex h-8 flex-row content-center items-center justify-start">
      <b class="logout-icon flex flex-[0_0_63px] justify-center opacity-60"
        ><mat-icon [svgIcon]="SparrowIcon.SignOut"
      /></b>
      <span [@animateText]="sideNavState ? 'show' : 'hide'" class="sp-body-12 cursor-pointer opacity-80!">Logout</span>
    </button>
  </div>
</div>
